import { hasValue } from 'Lib/Any';
import { last, sort, uniq } from 'ramda';

export type Severity = 'info' | 'success' | 'error' | 'warning' | undefined;

// Haven't found a good way to iterate over the types (or define the types from an ordered array)
// It could be better if Severity was an enum but there are other reasons to avoid those.
const priorityOrder: Severity[] = [undefined, 'info', 'success', 'warning', 'error'];

export const compare = (a: Severity, b: Severity) => {
  // Early equality check to avoid checking array indices
  if (a === b) return 0;

  return priorityOrder.indexOf(a) > priorityOrder.indexOf(b) ? 1 : -1;
};

export const getHighestSeverity = (s: Severity[]) => last(sort(compare, uniq(s.filter(hasValue))));
